import React from "react";
import "./Overview.css";

const Overview = () => {
  return (
    <section className="overview">
      <h6 className="section-title" > Our Products </h6>
      <p style={{color:"black"}}>
        At Chiselon Technologies, we don’t just build solutions for clients — we also innovate from within.
        Our in-house products solve real-world challenges across education, healthcare, human resources, and workforce management.
        Using AI/ML, Cloud, Microservices, and Mobile-first design, our platforms are transforming industries globally.
      </p>
    </section>
  );
};

export default Overview;
